/** Tokens de marca MontMar / SegurClassic para props SVG e inline styles. */

export const SEGURCLASSIC = {
  green: "#094032",
  lightGreen: "#255750",
  gold: "#DA9200",
  lightGold: "#D8A617",
  bg: "#F3F4F5",
} as const;

export const SEGURCLASSIC_DARK = {
  green: "#062820",
  lightGreen: "#0a3d32",
  gold: "#E5A020",
  lightGold: "#D8A617",
  bg: "#0a1f1a",
} as const;

export const MONTMAR = {
  navy: "#0E2643",
  navyDeep: "#081A30",
  emerald: "#059669",
  emeraldBright: "#10B77F",
} as const;

export const CHART = {
  emitidas: "#059669",
  errores: "#ef4444",
} as const;
